(function () {
  'use strict';

  var opener = null;

  function overlay() {
    return document.querySelector('[data-kms-search]');
  }

  function focusables(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll(
        'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return !el.hidden && el.offsetParent !== null;
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var open = event.target.closest('[data-kms-search-open]');
      if (open) {
        opener = open;
        return;
      }

      if (event.target.closest('[data-kms-search-close]')) {
        window.setTimeout(function () {
          if (opener && document.contains(opener)) opener.focus();
        }, 0);
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    var root = overlay();
    if (!root || !root.classList.contains('is-open')) return;

    if (event.key === 'Tab') {
      var items = focusables(root);
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    if (event.key === 'Escape') {
      window.setTimeout(function () {
        if (opener && document.contains(opener)) opener.focus();
      }, 0);
    }
  });
})();

(function () {
  'use strict';

  var home = document.getElementById('KalaManusHome');
  if (!home || home.querySelector('[data-km-launch-priority]')) return;

  var hero = home.querySelector('.km-hero-field');
  if (!hero) return;

  var section = document.createElement('section');
  section.className = 'km-launch-priority';
  section.setAttribute('data-km-launch-priority', '');

  section.innerHTML = `
    <div class="km-launch-priority-inner">
      <a
        class="km-launch-visual"
        href="/products/my-first-words-a-science-based-first-words-book-for-toddlers-ages-1-3"
        aria-label="Explore My First Words and early picture-book learning"
      >
        <span class="km-orbit-kicker">The world opens one word at a time</span>

        <span class="km-orbit-scene" aria-hidden="true">
          <svg class="km-orbit-crystal-bg" viewBox="0 0 900 780" preserveAspectRatio="xMidYMid slice">
            <defs>
              <linearGradient id="kmCrystalIvory" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stop-color="#fbf8f1"/>
                <stop offset=".55" stop-color="#f4f1e9"/>
                <stop offset="1" stop-color="#e8efe9"/>
              </linearGradient>
              <linearGradient id="kmCrystalSage" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stop-color="#e3ece6"/>
                <stop offset=".55" stop-color="#b8cec4"/>
                <stop offset="1" stop-color="#78998d"/>
              </linearGradient>
              <linearGradient id="kmCrystalDeep" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stop-color="#9bb5aa"/>
                <stop offset=".55" stop-color="#587d70"/>
                <stop offset="1" stop-color="#284f43"/>
              </linearGradient>
              <radialGradient id="kmCrystalLight" cx="64%" cy="39%" r="42%">
                <stop offset="0" stop-color="#ffffff" stop-opacity=".96"/>
                <stop offset=".16" stop-color="#ffffff" stop-opacity=".54"/>
                <stop offset=".52" stop-color="#f6f3ea" stop-opacity=".12"/>
                <stop offset="1" stop-color="#f6f3ea" stop-opacity="0"/>
              </radialGradient>
            </defs>

            <rect width="900" height="780" fill="url(#kmCrystalIvory)"/>

            <g class="km-crystal-facets km-crystal-facets-one">
              <polygon points="900,0 576,307 695,0" fill="#edf2ee"/>
              <polygon points="695,0 576,307 488,0" fill="#dfe9e3" opacity=".72"/>
              <polygon points="488,0 576,307 338,0" fill="#f9f7f1" opacity=".78"/>
              <polygon points="900,0 900,235 576,307" fill="#d4e1da" opacity=".7"/>
              <polygon points="900,235 900,464 576,307" fill="url(#kmCrystalSage)" opacity=".82"/>
              <polygon points="900,464 900,780 576,307" fill="url(#kmCrystalDeep)" opacity=".78"/>
              <polygon points="900,780 715,780 576,307" fill="#769488" opacity=".58"/>
              <polygon points="715,780 492,780 576,307" fill="#cbd9d1" opacity=".68"/>
              <polygon points="492,780 250,780 576,307" fill="#eef1ec" opacity=".86"/>
              <polygon points="250,780 0,780 576,307" fill="#f9f6ef" opacity=".92"/>
              <polygon points="0,780 0,558 576,307" fill="#f2efe7" opacity=".8"/>
              <polygon points="0,558 0,278 576,307" fill="#faf8f3" opacity=".88"/>
              <polygon points="0,278 0,0 576,307" fill="#f5f2ea" opacity=".9"/>
              <polygon points="0,0 338,0 576,307" fill="#fcfaf5" opacity=".72"/>
            </g>

            <g class="km-crystal-facets km-crystal-facets-two" opacity=".48">
              <polygon points="900,92 576,307 847,0" fill="#ffffff"/>
              <polygon points="900,545 576,307 900,362" fill="#244f43"/>
              <polygon points="816,780 576,307 900,702" fill="#4f7569"/>
              <polygon points="365,780 576,307 545,780" fill="#ffffff"/>
              <polygon points="0,665 576,307 151,780" fill="#ffffff"/>
              <polygon points="0,107 576,307 176,0" fill="#ffffff"/>
            </g>

            <g class="km-crystal-lines" fill="none" stroke-linecap="round">
              <path d="M576 307 L896 4" />
              <path d="M576 307 L900 235" />
              <path d="M576 307 L900 464" />
              <path d="M576 307 L900 777" />
              <path d="M576 307 L715 780" />
              <path d="M576 307 L492 780" />
              <path d="M576 307 L250 780" />
              <path d="M576 307 L0 780" />
              <path d="M576 307 L0 558" />
              <path d="M576 307 L0 278" />
              <path d="M576 307 L0 0" />
              <path d="M576 307 L338 0" />
              <path d="M576 307 L488 0" />
              <path d="M576 307 L695 0" />
              <path d="M52 685 C186 500 392 381 576 307 C716 251 808 145 862 24" />
              <path d="M88 744 C279 613 425 434 576 307 C686 214 743 103 778 7" />
              <path d="M618 774 C628 606 615 451 576 307 C548 203 533 102 550 5" />
            </g>

            <circle cx="576" cy="307" r="260" fill="url(#kmCrystalLight)"/>
            <circle class="km-crystal-core" cx="576" cy="307" r="18" fill="#ffffff" fill-opacity=".72"/>
            <circle cx="576" cy="307" r="28" fill="none" stroke="#c7a55c" stroke-opacity=".42"/>
            <circle cx="576" cy="307" r="42" fill="none" stroke="#ffffff" stroke-opacity=".32"/>
          </svg>

          <span class="km-orbit-ambient-light"></span>
          <span class="km-orbit-starfield"></span>

          <span class="km-orbit-system">
            <span class="km-orbit-shadow km-orbit-shadow-wide"></span>
            <span class="km-orbit-shadow km-orbit-shadow-contact"></span>

            <svg class="km-orbit-rings km-orbit-rings-back" viewBox="0 0 520 300">
              <ellipse class="km-orbit-ring-haze" cx="260" cy="150" rx="238" ry="78"/>
              <ellipse class="km-orbit-ring-line" cx="260" cy="150" rx="238" ry="78"/>
              <ellipse class="km-orbit-ring-motion" cx="260" cy="150" rx="238" ry="78"/>
              <ellipse class="km-orbit-ring-gold" cx="260" cy="150" rx="238" ry="78"/>
            </svg>

            <span class="km-orbit-planet">
              <span class="km-orbit-atmosphere"></span>
              <span class="km-orbit-polar-glow"></span>
              <span class="km-orbit-planet-glass"></span>
            </span>

            <svg class="km-orbit-rings km-orbit-rings-front" viewBox="0 0 520 300">
              <ellipse class="km-orbit-ring-haze" cx="260" cy="150" rx="238" ry="78"/>
              <ellipse class="km-orbit-ring-line" cx="260" cy="150" rx="238" ry="78"/>
              <ellipse class="km-orbit-ring-motion" cx="260" cy="150" rx="238" ry="78"/>
              <ellipse class="km-orbit-ring-gold" cx="260" cy="150" rx="238" ry="78"/>
            </svg>

            <span class="km-orbit-satellite-track km-orbit-satellite-track-one">
              <span class="km-orbit-satellite"></span>
            </span>
            <span class="km-orbit-satellite-track km-orbit-satellite-track-two">
              <span class="km-orbit-satellite"></span>
            </span>
          </span>
        </span>

        <span class="km-orbit-benefit km-orbit-benefit-one"><i>01</i><b>BUILD VOCABULARY</b></span>
        <span class="km-orbit-benefit km-orbit-benefit-two"><i>02</i><b>SHARED ATTENTION</b></span>
        <span class="km-orbit-benefit km-orbit-benefit-three"><i>03</i><b>WORD-TO-WORLD LINKS</b></span>
        <span class="km-orbit-benefit km-orbit-benefit-four"><i>04</i><b>LANGUAGE CONFIDENCE</b></span>

        <span class="km-orbit-caption">Early language · Picture books · Real-world learning</span>
      </a>

      <div class="km-launch-copy">
        <p class="km-launch-label">The launch begins here · My First Words</p>
        <h2>Before a child can use more words, they need more moments to <em>share them.</em></h2>
        <p><strong>My First Words</strong> turns 55 useful everyday words into a calm real-photo reading routine for ages 1 to 3. Look together. Name what matters. Wait. Point. Repeat. Let a familiar word move from the page into the child’s actual day.</p>

        <div class="km-launch-proof">
          <div><strong>Real photographs</strong><span>Concrete objects that connect the page to real life.</span></div>
          <div><strong>55 everyday words</strong><span>Useful vocabulary, not a random picture list.</span></div>
          <div><strong>No performance pressure</strong><span>Looking, pointing, listening, sounds, and words can all participate.</span></div>
        </div>

        <div class="km-launch-actions">
          <a href="/products/my-first-words-a-science-based-first-words-book-for-toddlers-ages-1-3">Look inside My First Words →</a>
          <a href="/collections/my-first-words">Explore the First Words series</a>
        </div>
      </div>

      <div class="km-launch-sequence">
        <p>Launch sequence</p>
        <a class="km-launch-step" href="/products/my-first-words-a-science-based-first-words-book-for-toddlers-ages-1-3">
          <b>01</b><div><strong>My First Words</strong><span>Language starts here</span></div>
        </a>
        <a class="km-launch-step" href="/collections/animals">
          <b>02</b><div><strong>Animals</strong><span>Real science, real wonder</span></div>
        </a>
        <a class="km-launch-step" href="/collections/what-robots-can-t-do">
          <b>03</b><div><strong>What Robots Can’t Do</strong><span>Human capacities, made visible</span></div>
        </a>
      </div>
    </div>
  `;

  hero.insertAdjacentElement('afterend', section);

  var card = section.querySelector('.km-launch-visual');
  var hoverMedia = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (card && hoverMedia && hoverMedia.matches && !reducedMotion) {
    var frame = 0;

    card.addEventListener('pointermove', function (event) {
      if (frame) window.cancelAnimationFrame(frame);

      frame = window.requestAnimationFrame(function () {
        var rect = card.getBoundingClientRect();
        var px = (event.clientX - rect.left) / rect.width;
        var py = (event.clientY - rect.top) / rect.height;

        card.style.setProperty('--orbit-ry', ((px - 0.5) * 6.5).toFixed(2) + 'deg');
        card.style.setProperty('--orbit-rx', ((0.5 - py) * 5.5).toFixed(2) + 'deg');
        card.style.setProperty('--light-x', (px * 100).toFixed(1) + '%');
        card.style.setProperty('--light-y', (py * 100).toFixed(1) + '%');
      });
    });

    card.addEventListener('pointerleave', function () {
      card.style.setProperty('--orbit-ry', '0deg');
      card.style.setProperty('--orbit-rx', '0deg');
      card.style.setProperty('--light-x', '64%');
      card.style.setProperty('--light-y', '39%');
    });
  }
})();
